// OWNED BY THE CHAT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the CHAT
// work and the rest of the app can be written at the same time without two
// people editing one map.
export const chat = {
  // ── the chat page — core.md §9 ───────────────────────────────────────
  'chat.title': 'دستیار آموزشی',
  'chat.landing.title': 'دربارهٔ کدام بیمار می‌خواهید گفتگو کنید؟',
  'chat.landing.body': 'دستیار کل پروندهٔ آن بیمار را می‌شناسد — شرح حال، ویزیت‌ها، تشخیص‌ها و دستورات.',
  'chat.landing.new': 'بیمار جدید',
  'chat.landing.open': 'گفتگو دربارهٔ {{name}}',
  'chat.sidebar.title': 'گفتگوها',
  'chat.sidebar.new': 'گفتگوی جدید',
  'chat.sidebar.today': 'امروز',
  'chat.sidebar.yesterday': 'دیروز',
  'chat.sidebar.last7': '۷ روز گذشته',
  'chat.sidebar.older': 'قدیمی‌تر',
  'chat.sidebar.empty': 'هنوز گفتگویی نیست.',
  'chat.sidebar.otherPatient': 'بیمار دیگر',
  'chat.sidebar.inVisit': 'گفتگوهای داخل ویزیت',
  'chat.sidebar.collapse': 'پنهان کردن گفتگوها',
  'chat.sidebar.expand': 'نمایش گفتگوها',
  'chat.sidebar.menu': 'عملیات گفتگو',
  'chat.sidebar.justNow': 'همین حالا',
  'chat.sidebar.minutesAgo': '{{count}} دقیقه پیش',
  'chat.sidebar.hoursAgo': '{{count}} ساعت پیش',
  'chat.thread.untitled': 'گفتگوی جدید',
  'chat.thread.renameTitle': 'تغییر نام گفتگو',
  'chat.thread.renamePlaceholder': 'عنوان گفتگو',
  'chat.thread.renameHelper': 'خالی بگذارید تا عنوان خودکار برگردد.',
  'chat.thread.renamed': 'نام تغییر کرد.',
  'chat.thread.deleteTitle': 'این گفتگو حذف شود؟',
  'chat.thread.deleteBody': 'پرسش‌ها و پاسخ‌ها حذف می‌شوند؛ بیمار باقی می‌ماند.',
  'chat.thread.deleted': 'گفتگو حذف شد.',
  'chat.thread.notFound': 'گفتگو پیدا نشد — گفتگوی تازه‌ای آغاز می‌شود.',
  'chat.thread.notFoundToast': 'گفتگو پیدا نشد',
  'chat.thread.movedToast': 'پاسخ در گفتگوی قبلی ثبت شد.',
  'chat.header.back': 'بازگشت به پرونده',
  'chat.header.patient': 'بیمار',
  'chat.empty.title': 'دربارهٔ {{name}} بپرسید',
  'chat.empty.body': 'هر پاسخ در همین گفتگو ثبت می‌شود و پارسه خرج می‌کند — هزینه روی دکمه نوشته شده است.',
  'chat.prompts.summary': 'این پرونده را خلاصه کن',
  'chat.prompts.differential': 'تشخیص‌های افتراقی را با استدلال بگو',
  'chat.prompts.keyFinding': 'کدام یافته مهم‌تر است و چرا؟',
  'chat.prompts.nextVisit': 'برای ویزیت بعدی چه بپرسم؟',
  'chat.prompts.summaryOf': '{{name}} را خلاصه کن',
  'chat.prompts.differentialFor': 'تشخیص‌های افتراقی «{{complaint}}» را با استدلال بگو',
  'chat.prompts.keyFindingFor': 'در «{{complaint}}» کدام یافته مهم‌تر است و چرا؟',
  'chat.composer.placeholder': 'دربارهٔ این بیمار بپرسید…',
  'chat.composer.send': 'ارسال',
  'chat.composer.stop': 'توقف',
  'chat.composer.thinking': 'در حال فکر کردن…',
  'chat.composer.counter': '{{count}} / {{max}}',
  'chat.composer.offline': 'آفلاین',
  'chat.composer.reserved': 'پرسش نمی‌تواند با دو زیرخط شروع شود.',
  'chat.composer.tooLong': 'پرسش حداکثر ۴۰۰۰ نویسه می‌تواند باشد.',
  'chat.composer.noCredits': 'پارسهٔ کافی ندارید',
  'chat.message.you': 'شما',
  'chat.message.assistant': 'دستیار',
  'chat.message.sending': 'در حال ارسال',
  'chat.message.sent': 'ارسال شد',
  'chat.message.failed': 'ارسال نشد',
  'chat.message.retry': 'تلاش مجدد',
  'chat.message.copy': 'کپی',
  'chat.message.copied': 'کپی شد',
  'chat.message.regenerate': 'بازتولید',
  'chat.message.thumbsUp': 'مفید بود',
  'chat.message.thumbsDown': 'مفید نبود',
  'chat.message.older': 'پیام‌های قدیمی‌تر',
  'chat.message.loadingOlder': 'در حال بارگذاری…',
  'chat.message.typing': 'دستیار در حال فکر کردن است',
  'chat.followUps': 'پرسش بعدی',
  'chat.references': 'منابع ذکرشده',
  'chat.confidenceLabel': 'اطمینان',
  'chat.confidence.low': 'کم',
  'chat.confidence.medium': 'متوسط',
  'chat.confidence.high': 'زیاد',
  'chat.kind.chat': 'پرسش',
  'chat.kind.differential': 'تشخیص افتراقی',
  'chat.kind.interaction': 'بررسی تداخل',
  'chat.kind.soap_suggest': 'پیشنهاد SOAP',
  'chat.kind.order_suggest': 'پیشنهاد دستورات',
  'chat.error.title': 'این گفتگو بارگذاری نشد',
  'chat.noCredits.title': 'پارسه کافی نیست',
  'chat.noCredits.body': 'پرسش شما به جعبهٔ نوشتن برگشت. شارژ کنید و دوباره بفرستید.',
  'chat.noCredits.action': 'شارژ',
};

export default chat;
